import { render, staticRenderFns } from "./ProviderSchedule.vue?vue&type=template&id=63bed2e8&scoped=true"
import script from "./ProviderSchedule.vue?vue&type=script&lang=js"
export * from "./ProviderSchedule.vue?vue&type=script&lang=js"
import style0 from "./ProviderSchedule.vue?vue&type=style&index=0&id=63bed2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bed2e8",
  null
  
)

export default component.exports